import './index.erb';
import './index.rb';
import styles from './index.module.scss';
import { Application, Controller } from 'utils/stimulus';

export class CourseSuggestionsFilter extends Controller {
  connect() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.sendEventToAnalytics();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 1 }
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.disconnect();
  }

  mountCourseCard(tags, title, subtitle, url) {
    return `
  <div class="${styles.qCourseCard}">
    <div>
      <div class="${styles.courseCardHeader}">
        <i class="q-icon q-icon-landmark-2"></i>
        <div class="${styles.courseCardBadges}">
          ${tags.map(tag => `<p>${tag}</p>`).join('')}
        </div>
      </div>
      <div class="${styles.courseCardMain}">
        <span class="${styles.courseName}">${title}</span>
        <span class="${styles.courseInfo}">${subtitle}</span>
      </div>
    </div>
    <div class="${styles.courseCardFooter}">
      <a class="${
        styles.ctaCourseButton
      }" href="${url}" target="_blank" data-action="click->q-course-suggestions-container#handleButtonClick">Ver detalhes do curso</a>
    </div>
  </div>`;
  }

  getInstitutesIds() {
    const url = window.location.href;
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);
    const institutesIds = params.getAll('institute_ids[]');
    return institutesIds;
  }

  getRandomInstituteId(array) {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
  }

  sendEventToAnalytics() {
    UserTracker.emit('event', {
      eventName: 'courses sugestion viewed'
    });
  }

  handleButtonClick() {
    UserTracker.emit('event', {
      eventName: 'courses sugestion clicked'
    });
  }

  async getSuggestionsCourses(instituteId) {
    const qs = {
      institute_id: instituteId
    };

    try {
      const data = await Thor.StudyGuides.search({}, { qs });

      if (data) {
        $(`.${styles['institute-name']}`).text(data.institute_name);
        data.study_guides.map(item => {
          $(`.${styles['courses-cards-container']}`).append(
            this.mountCourseCard(item.tags, item.title, item.subtitle, item.url)
          );
        });
        $('.course-suggestion-container').removeClass('hidden');
      }
    } catch (error) {
      Rollbar.error(
        '[front] Unable to render experiment_course_suggestions_filter component.',
        error
      );
    }
  }

  init() {
    const institutesIds = this.getInstitutesIds();
    const instituteId = this.getRandomInstituteId(institutesIds);
    this.getSuggestionsCourses(instituteId);
  }
}

global.CourseSuggestionsFilterApplication =
  global.CourseSuggestionsFilterApplication || Application.start();
global.CourseSuggestionsFilterApplication.register(
  'q-course-suggestions-container',
  CourseSuggestionsFilter
);
